import { useIdPAuth } from "./idp-auth";
import { Navbar } from "./Navbar";

type NavbarContainerProps = {
  showProductSwitcher: boolean;
  showUserMenu: boolean;
};

export const NavbarContainer = ({ showProductSwitcher, showUserMenu }: NavbarContainerProps) => {
  const { user } = useIdPAuth();
  const name = `${user?.given_name ?? ""} ${user?.family_name ?? ""}`;
  const email = user?.email ?? "";

  return (
    <Navbar
      showProductSwitcher={showProductSwitcher}
      showUserMenu={showUserMenu}
      name={name}
      email={email}
    />
  );
};
